// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThumbDislikeButton_wrapper__BALxJ","icon":"ThumbDislikeButton_icon__U5yV4","count":"ThumbDislikeButton_count__SyFcj"};